import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';

interface CoverageFilterProps {
  filterIndex: number;
}

/**
 * Renders radio buttons for filtering sessions by coverage status
 */
export const CoverageFilter = ({ filterIndex }: CoverageFilterProps) => {
  const { t } = useTranslation();
  const { control, getValues } = useFormContext();

  const { update } = useFieldArray({ control, name: 'filters' });

  const isCovered = useWatch({ control, name: `filters.${filterIndex}.isCovered` });

  const handleChange = (value: string) => {
    let booleanValue: boolean | null;
    if (value === 'true') {
      booleanValue = true;
    } else if (value === 'false') {
      booleanValue = false;
    } else {
      booleanValue = null; // 'all' option
    }
    const currentFilter = getValues(`filters.${filterIndex}`);
    update(filterIndex, { ...currentFilter, isCovered: booleanValue });
  };

  return (
    <div className="space-y-3">
      <RadioGroup
        value={isCovered?.toString() || ''}
        onValueChange={handleChange}
        className="gap-0"
      >
        <div className="flex items-center space-x-2 rounded-sm px-2 py-1.5 hover:bg-highlight-background">
          <RadioGroupItem value="true" id={`covered-true-${filterIndex}`} />
          <Label htmlFor={`covered-true-${filterIndex}`} className="cursor-pointer font-normal">
            {t('analytics.filters.onlyCoveredConversations')}
          </Label>
        </div>
        <div className="flex items-center space-x-2 rounded-sm px-2 py-1.5 hover:bg-highlight-background">
          <RadioGroupItem value="false" id={`covered-false-${filterIndex}`} />
          <Label htmlFor={`covered-false-${filterIndex}`} className="cursor-pointer font-normal">
            {t('analytics.filters.hideCoveredConversations')}
          </Label>
        </div>
      </RadioGroup>
    </div>
  );
};
